/**
 * Created by tomers on 12/28/2016.
 */
define(function(require) {
    "use strict";

    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");
    var BaseDataManager = require("controllers/BaseDataManager");

    var SettingsCollection = require("collections/SettingsCollection");
    var AuditTrailCollection = require("manager-collections/audit-trail/AuditTrailCollection");
    var ApiKeysCollection = require("manager-collections/data-sources/api-keys/ApiKeysCollection");
    var ApiKeysGalleryCollection = require("manager-collections/data-sources/api-keys/ApiKeysGalleryCollection");
    var ApiFullListModel = require("manager-models/data-sources/api-keys/ApiFullListModel");
    var AppKeysCollection = require("manager-collections/data-sources/integrations/app-keys/AppKeysCollection");
    var AppKeysGalleryCollection = require("manager-collections/data-sources/integrations/app-keys/AppKeysGalleryCollection");
    var AuthenticationServerCollection = require("manager-collections/data-sources/integrations/authentication/AuthenticationServerCollection");
    var ConversationSourcesGalleryCollection = require("manager-collections/data-sources/conversation-sources/ConversationSourcesGalleryCollection");

    var ConnectorsCollection = require("manager-collections/data-sources/conversation-sources/ConnectorsCollection");
    var UsersCollection = require("collections/entities/UsersCollection");
    var SpecialOccasionsCollection = require("collections/entities/SpecialOccasionsCollection");
    var SchedulesCollection = require("collections/entities/SchedulesCollection");
    var ProfilesCollection = require("collections/entities/ProfilesCollection");
    var Settings = require("codeTables/settings.json");
    var SiteSettingsModel = require("models/SiteSettingsModel");

    var ENTITY_ENUM = {
        AUDIT_TRAIL: AuditTrailCollection.NAME,
        SITE_SETTINGS_MY_DETAILS: "SiteSettingsMyDetailsCollection",
        SITE_SETTINGS_AGENT_MANAGER: "SiteSettingsAgentManagerCollection",
        API_KEYS: ApiKeysCollection.NAME,
        API_KEYS_GALLERY: ApiKeysGalleryCollection.NAME,
        API_FULL_LIST: ApiFullListModel.NAME,
        APP_KEYS: AppKeysCollection.NAME,
        APP_KEYS_GALLERY: AppKeysGalleryCollection.NAME,
        AUTHENTICATION_SERVER: AuthenticationServerCollection.NAME,
        CONNECTORS: ConnectorsCollection.NAME,
        USERS: UsersCollection.NAME,
        PROFILES: ProfilesCollection.NAME,
        SOFTWARES: "", //the name will be added dynamically
        CONVERSATION_SOURCES_GALLERY: ConversationSourcesGalleryCollection.NAME,
        APP_INSTALLS: "", //the name will be added dynamically
        SPECIAL_OCCASIONS: SpecialOccasionsCollection.NAME,
        SCHEDULES: SchedulesCollection.NAME,
        SITE_SETTINGS_MANUAL_SHIFT_STATUS: "SiteSettingsManualShiftStatusModel",
        SKILLS: "", //the name will be added dynamically
        LOBS: "", //the name will be added dynamically
        CAMPAIGNS: "" //the name will be added dynamically
    };

    var ManagerDataManager = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ManagerDataManager = BaseDataManager.extend({
            initialize: function(options) {
                this._initialize(options);
            },
            getEntities: function() {
                return this._getEntities();
            },
            getDependencyData: function(dependencyModel) {
                return this._getDependencyData(dependencyModel);
            },
            verifyCampaigns: function() {
                return this._verifyCampaigns();
            },

            _initialize: function(options) {
                BaseDataManager.prototype.initialize.call(this, options);

                this._initData();
                this._bindEvents();
            },

            _initData: function() {
                var siteSettingsMyDetailsOptions = {
                    groups: SettingsCollection.SETTINGS_ENUM.SETTING_GROUP.myDetailsSettings,
                    contextType: SettingsCollection.SETTINGS_ENUM.CONTEXT_TYPE.USER,
                    contextId: LE.sessionManager.getUserId(),
                    contextCascading: true
                };
                var siteSettingsAgentManagerOptions = {
                    groups: SettingsCollection.SETTINGS_ENUM.SETTING_GROUP.msggw,
                    contextType: SettingsCollection.SETTINGS_ENUM.CONTEXT_TYPE.ACCOUNT,
                    contextCascading: true
                };
                var siteSettingsShiftStatusManualOptions = {
                    id: Settings.SETTING_ID.SHIFT_STATUS_MANUAL,
                    contextType: Settings.CONTEXT_TYPE.ACCOUNT,
                    contextCascading: true
                };

                this.addDataObj(ENTITY_ENUM.AUDIT_TRAIL, new AuditTrailCollection(), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_MY_DETAILS, new SettingsCollection([], siteSettingsMyDetailsOptions), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_AGENT_MANAGER, new SettingsCollection([], siteSettingsAgentManagerOptions), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.API_KEYS, new ApiKeysCollection(), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.API_KEYS_GALLERY, new ApiKeysGalleryCollection());
                this.addDataObj(ENTITY_ENUM.API_FULL_LIST, new ApiFullListModel(), {isMandatory:false, fetchInterval:Infinity});
                this.addDataObj(ENTITY_ENUM.APP_KEYS, new AppKeysCollection(), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.APP_KEYS_GALLERY, new AppKeysGalleryCollection());
                this.addDataObj(ENTITY_ENUM.AUTHENTICATION_SERVER, new AuthenticationServerCollection(), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.CONNECTORS, new ConnectorsCollection(), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.USERS, new UsersCollection(), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.PROFILES, new ProfilesCollection(), {isMandatory:true, fetchInterval:0});
                this.addDataObj(ENTITY_ENUM.CONVERSATION_SOURCES_GALLERY, new ConversationSourcesGalleryCollection());
                this.addDataObj(ENTITY_ENUM.SPECIAL_OCCASIONS, new SpecialOccasionsCollection(), {isMandatory:true});
                this.addDataObj(ENTITY_ENUM.SCHEDULES, new SchedulesCollection(), {isMandatory:true});
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_MANUAL_SHIFT_STATUS, new SiteSettingsModel(siteSettingsShiftStatusManualOptions), {isMandatory:true});

                var softwaresCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSoftwaresCollection);
                ENTITY_ENUM.SOFTWARES = softwaresCollection.name;
                this.addDataObj(ENTITY_ENUM.SOFTWARES, softwaresCollection);

                var appInstallsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAppInstallsCollection);
                ENTITY_ENUM.APP_INSTALLS = appInstallsCollection.name;
                this.addDataObj(ENTITY_ENUM.APP_INSTALLS, appInstallsCollection);

                var skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);
                ENTITY_ENUM.SKILLS = skillsCollection.name;
                this.addDataObj(ENTITY_ENUM.SKILLS, skillsCollection, {isMandatory:true});

                var lobsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLobsCollection);
                ENTITY_ENUM.LOBS = lobsCollection.name;
                this.addDataObj(ENTITY_ENUM.LOBS, lobsCollection, {isMandatory:true});

                // we need to defer the crossModule to campaigns because Campaigns module is initialized after Manager module, so we need to wait until it's initialized
                if (LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE)) {
                    _.defer(_.bind(this._verifyCampaigns, this));
                }
            },

            _verifyCampaigns: function() {
                // we need to defer the crossModule to campaigns because Campaigns module is initialized after Manager module, so we need to wait until it's initialized
                if (LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE) && _.isEmpty(ENTITY_ENUM.CAMPAIGNS)) {
                    var campaignsCollection = LE.crossModule("campaigns", LE.media.actions.request, LE.mediaCodes.campaigns.reqres.getCampaignsCollection);
                    ENTITY_ENUM.CAMPAIGNS = campaignsCollection.name;
                    this.addDataObj(ENTITY_ENUM.CAMPAIGNS, campaignsCollection, {isMandatory:true});
                }

                return (!_.isEmpty(ENTITY_ENUM.CAMPAIGNS));
            },

            _bindEvents: function() {
                this.listenTo(this.getData(ENTITY_ENUM.API_KEYS), "fetch:success", this._prepareApiKeysGalleryCollection);
                this.listenTo(this.getData(ENTITY_ENUM.APP_KEYS), "fetch:success", this._prepareAppKeysGalleryCollection);
                this.listenTo(this.getData(ENTITY_ENUM.CONNECTORS), "fetch:success", this._prepareConversationSourcesGalleryCollection);
                this.listenTo(this.getData(ENTITY_ENUM.API_FULL_LIST), "fetch:success", this._prepareApiFullList);
                this.listenTo(this.getData(ENTITY_ENUM.SOFTWARES), "fetch:success", this._prepareConversationSourcesGalleryCollection);
                this.listenTo(this.getData(ENTITY_ENUM.APP_INSTALLS), "fetch:success", this._prepareConversationSourcesGalleryCollection);
            },

            _prepareApiKeysGalleryCollection: function() {
                var apiKeysCollection = this.getData(ENTITY_ENUM.API_KEYS);
                var apiKeysGalleryCollection = this.getData(ENTITY_ENUM.API_KEYS_GALLERY);
                var ApiKeyGalleryModel = apiKeysGalleryCollection.model;

                apiKeysGalleryCollection.reset();
                apiKeysCollection.each(function(apiKeyModel) {
                    var apiKeysGalleryModelObj = {};

                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.DATE_CREATED] = apiKeyModel.getDateCreated();
                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.NAME] = apiKeyModel.getName();
                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.DESCRIPTION] = apiKeyModel.getDescription();
                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.HAS_IP_RESTRICTION] = (apiKeyModel.getIpRestrictionRanges().length > 0);
                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.APIKEY] = apiKeyModel.getApiKey();
                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.APIKEY_SECRET] = apiKeyModel.getApiKeySecret();
                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.ACCESSTOKEN] = apiKeyModel.getAccessToken();
                    apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.ACCESSTOKEN_SECRET] = apiKeyModel.getAccessTokenSecret();

                    var active = apiKeyModel.isActive();
                    if (!_.isUndefined(active)){
                        apiKeysGalleryModelObj[ApiKeyGalleryModel.KEYS.ACTIVE] = active;
                    }

                    apiKeysGalleryCollection.add(apiKeysGalleryModelObj);
                });
            },

            _prepareAppKeysGalleryCollection: function() {
                var appKeysCollection = this.getData(ENTITY_ENUM.APP_KEYS);
                var appKeysGalleryCollection = this.getData(ENTITY_ENUM.APP_KEYS_GALLERY);
                var AppKeyGalleryModel = appKeysGalleryCollection.model;

                appKeysGalleryCollection.reset();
                appKeysCollection.each(function(appKeyModel){
                    var appKeyGalleryModelObj = {};

                    var testText = (!appKeyModel.getDevApp()) ? " " + LE.translator.translate("LEManager.manager.dataSources.appKey.gallery.devApp.title") : "";
                    appKeyGalleryModelObj[AppKeyGalleryModel.KEYS.DATE_CREATED] = appKeyModel.getDateCreated();
                    appKeyGalleryModelObj[AppKeyGalleryModel.KEYS.APPLICATION_KEY] = appKeyModel.getAppKey();
                    appKeyGalleryModelObj[AppKeyGalleryModel.KEYS.NAME] = appKeyModel.getName() + testText;
                    appKeyGalleryModelObj[AppKeyGalleryModel.KEYS.DESCRIPTION] = LE.translator.translate('LEManager.manager.dataSources.appKey.gallery.description') + appKeyModel.getAppKey();
                    appKeyGalleryModelObj[AppKeyGalleryModel.KEYS.OPERATING_SYSTEM] = appKeyModel.getOperatingSystem();
                    appKeyGalleryModelObj[AppKeyGalleryModel.KEYS.CERTIFICATE] = appKeyModel.getCertificate();
                    appKeyGalleryModelObj[AppKeyGalleryModel.KEYS.KEY] = appKeyModel.getKey();

                    appKeysGalleryCollection.add(appKeyGalleryModelObj);
                });
            },

            _prepareConversationSourcesGalleryCollection: function() {
                var appInstallCollection = this.getData(ENTITY_ENUM.APP_INSTALLS);
                var softwaresCollection = this.getData(ENTITY_ENUM.SOFTWARES);
                var connectorsCollection = this.getData(ENTITY_ENUM.CONNECTORS);

                //if we don't have the c4m flag, then we don't need to wait for all three collections to fetch. we only need the connectors like it was until today.
                if (connectorsCollection.isLastFetchReturnedSuccess() && (!LEConfig.c4mMobileApp || (appInstallCollection.isLastFetchReturnedSuccess() && softwaresCollection.isLastFetchReturnedSuccess()))) {

                    var conversationSourcesGalleryCollection = this.getData(ENTITY_ENUM.CONVERSATION_SOURCES_GALLERY);
                    var ConversationSourcesGalleryModel = conversationSourcesGalleryCollection.model;
                    var AppInstallModel = appInstallCollection.model;

                    //add the web model
                    var webConversationSourcesGalleryModelObj = {};
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ID] = AppInstallModel.SPECIAL_SOURCES_IDS.WEB;
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.NAME] = LE.translator.translate("LEManager.dataSources.marketplace.gallery.web.name");
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.LOGO_URI] = window.leImageBaseUrl + "src/modules/campaigns/assets/img/software/Web.png";
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.SHORT_DESCRIPTION] = LE.translator.translate("LEManager.dataSources.marketplace.gallery.web.description.short");
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.FULL_DESCRIPTION] = LE.translator.translate("LEManager.dataSources.marketplace.gallery.web.description.full");
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.CONFIGURABLE] = false;
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.CONFIGURED] = true;
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ENABLED] = true;
                    webConversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.PATH] = "lptag";

                    conversationSourcesGalleryCollection.reset(webConversationSourcesGalleryModelObj);

                    if (LEConfig.c4mMobileApp) {
                        softwaresCollection.each(_.bind(function(softwareModel) {
                            if (!_.isEmpty(softwareModel.getCapabilities().engagement)) {
                                var conversationSourcesGalleryModelObj;
                                var softwareId = softwareModel.getSoftwareId();
                                var appInstallModels = appInstallCollection.getAppInstallModelBySoftwareId(softwareId);
                                if(!_.isEmpty(appInstallModels)) {

                                    _.each(appInstallModels, function(appInstallModel) {
                                        conversationSourcesGalleryModelObj = {};
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ID] = appInstallModel.id;
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.NAME] = appInstallModel.getName();
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.LOGO_URI] = appInstallModel.getLogoUri();
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.SHORT_DESCRIPTION] = softwareModel.getShortDescription();
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.FULL_DESCRIPTION] = softwareModel.getLongDescription();
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.PATH] = "data/sources/" + softwareId +  "/" + appInstallModel.id;
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ENABLED] = appInstallModel.getEnabled();
                                        conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.CONFIGURED] = true;

                                        conversationSourcesGalleryCollection.add(conversationSourcesGalleryModelObj);
                                    });
                                }
                                else {
                                    conversationSourcesGalleryModelObj = {};
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ID] = softwareId;
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.NAME] = softwareModel.getName();
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.LOGO_URI] = softwareModel.getLogoUri();
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.SHORT_DESCRIPTION] = softwareModel.getShortDescription();
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.FULL_DESCRIPTION] = softwareModel.getLongDescription();
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.PATH] = "data/sources/" + softwareId +  "/new";
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ENABLED] = false;
                                    conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.CONFIGURED] = false;

                                    conversationSourcesGalleryCollection.add(conversationSourcesGalleryModelObj);
                                }
                            }
                        }, this));
                    }

                    //adding connectors
                    if (LE.sessionManager.hasConversationSourcesFeature()) {
                        _.each(connectorsCollection.SOURCE_TYPES, function(sourceType) {
                            var configurationType = connectorsCollection.getConnectorConfigurationByType(sourceType);
                            var isAllowed = _.result(configurationType, "isAllowed");
                            if (isAllowed) {
                                var connectorsByTypeArr = connectorsCollection.getConnectorsByType(sourceType);

                                var conversationSourcesGalleryModelObj = {};
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ID] = sourceType;
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.NAME] = LE.translator.translate("LEManager.dataSources.conversationSources.gallery."+configurationType.key+".name");
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.TYPE] = sourceType;
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.LOGO_URI] = configurationType.logo_uri;
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.SHORT_DESCRIPTION] = LE.translator.translate("LEManager.dataSources.conversationSources.gallery."+configurationType.key+".description.short");
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.FULL_DESCRIPTION] = LE.translator.translate("LEManager.dataSources.conversationSources.gallery."+configurationType.key+".description.full");
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.PATH] = configurationType.path;
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.CONFIGURABLE] = !_.isEmpty(configurationType.ConfigModel);
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.CONFIGURED] = !_.isEmpty(connectorsByTypeArr);
                                conversationSourcesGalleryModelObj[ConversationSourcesGalleryModel.KEYS.ENABLED] = !_.isEmpty(connectorsByTypeArr) && connectorsByTypeArr[0].getEnabled();

                                conversationSourcesGalleryCollection.add(conversationSourcesGalleryModelObj);
                            }
                        });
                    }
                }

            },

            _prepareApiFullList: function() {
                this.getData(ENTITY_ENUM.API_FULL_LIST).set("fullListTitle", LE.translator.translate("LEManager.manager.dataSources.Api_Keys.full_list.title"));
                this.getData(ENTITY_ENUM.API_FULL_LIST).set("coming_soon", LE.translator.translate("LEManager.manager.dataSources.Api_Keys.coming_soon"));
                this.getData(ENTITY_ENUM.API_FULL_LIST).set("beta", LE.translator.translate("LEManager.manager.dataSources.Api_Keys.beta"));
            },

            _getDependencyData: function(dependencyModel) {
                return this["_getDependencyData" + dependencyModel.get("type")](dependencyModel);
            },
            _getDependencyDataACSkillObject: function(dependencyModel) {
                var skillId = parseInt(dependencyModel.id, 10);
                var skillModel = this.getData(ENTITY_ENUM.SKILLS).get(skillId);
                var skillName = (skillModel) ? skillModel.getName() : "#" + dependencyModel.id;
                var lobIdsArr = [];
                var lobNamesArr = [];
                var lobNamesStr = "";

                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    lobIdsArr = (skillModel) ? skillModel.getLobs() : [];
                    _.each(lobIdsArr, _.bind(function(lobId) {
                        lobNamesArr.push(this.getNameById(ENTITY_ENUM.LOBS, lobId));
                    }, this));
                    lobNamesStr = lobNamesArr.join(", ");
                }

                return {
                    name: skillName,
                    subText: lobNamesStr,
                    isClickable: false,
                    url: ""
                };
            },
            _getDependencyDataLECampaignObject: function(dependencyModel) {
                var dependencyData;
                if (LEConfig.scheduledCampaigns && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE)) {
                    dependencyData = LE.crossModule("campaigns", LE.media.actions.request, LE.mediaCodes.campaigns.reqres.getDependencyData, dependencyModel);
                    if (dependencyData) {
                        dependencyData.isClickable = false;
                        dependencyData.url = "";
                    }
                }
                return dependencyData;
            },

            _getEntities: function() {
                return ENTITY_ENUM;
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    ManagerDataManager.ENTITY_ENUM = ENTITY_ENUM;

    return ManagerDataManager;
});
